import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';

import { getNFTsInWallet } from '@/api/loans';
import { IResponseNFT } from '@/api/loans/model';

interface IPropsUseWalletNFTsSimplehash<T> {
  contractAddress?: T;
  order_by?: string;
  limit?: number;
  collectionIds?: string;
}

type SimplifiedData = { nextCursors: string[]; nfts: IResponseNFT['result'] };
type fnReturnType<T> = T extends string | null | undefined ? IResponseNFT : SimplifiedData;

export const useWalletNFTsSimplehash = <T extends string | string[] | null | undefined>({ contractAddress, order_by, limit, collectionIds }: IPropsUseWalletNFTsSimplehash<T>) => {
  const { address } = useAccount();

  return useQuery<fnReturnType<T>>({
    queryKey: ['wallet-nfts-simplehash', contractAddress, address, collectionIds],
    queryFn: () => {
      return getNFTsInWallet(address!, null, contractAddress, order_by, limit, collectionIds) as Promise<fnReturnType<T>>;
    },
    enabled: !!address,
  });
};
